var DevOps = "DevOps";
var Gaming = "Trò chơi";
var Migration = "Di chuyển";
var Other = "Khác";
var useCase = {
	"Use case": "Trường hợp sử dụng",
	"AI & machine learning": "AI và Machine Learning",
	"Batch processing": "Xử lý hàng loạt",
	"Big data, analytics, & business intelligence": "Dữ liệu lớn, Phân tích và Trí tuệ doanh nghiệp",
	"Business applications - Microsoft": "Ứng dụng dành cho doanh nghiệp – Microsoft",
	"Business applications - Oracle": "Ứng dụng dành cho doanh nghiệp – Oracle",
	"Business applications - Other": "Ứng dụng dành cho doanh nghiệp – Khác",
	"Business applications - SAP": "Ứng dụng dành cho doanh nghiệp – SAP",
	"Content delivery": "Phân phối nội dung",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "Internet of Things",
	"Learning & certification": "Học tập và Chứng nhận",
	"Media services": "Dịch vụ truyền thông",
	Migration: Migration,
	"Mobile applications": "Ứng dụng di động",
	Other: Other,
	"Storage & backup": "Lưu trữ & sao lưu",
	"Websites & web apps": "Trang web và Ứng dụng web"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
